var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-center mb-3"
            },
            [
              _c(
                "div",
                {
                  staticClass: "body-1 mr-auto"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pb-1",
                      attrs: {
                        size: "24",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-monitor")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ml-2"
                    },
                    [_vm._v("Console")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "kvm-caption text-caption ml-2"
                    },
                    [
                      _vm._v(
                        "Graphical — for troubleshooting. For everyday access use the Terminal."
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-chip",
                {
                  staticClass: "kvm-status mr-2",
                  class: "kvm-status--" + _vm.status,
                  attrs: {
                    small: "",
                    label: "",
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "kvm-sr-only"
                    },
                    [_vm._v("Console status: ")]
                  ),
                  _vm._v(_vm._s(_vm.statusChip.text) + " ")
                ]
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "kvm-action kvm-action--green mr-2",
                  attrs: {
                    small: "",
                    tile: "",
                    outlined: "",
                    color: "primary",
                    disabled: _vm.status !== "connected",
                    "aria-label": "Paste text into the console"
                  },
                  on: {
                    click: _vm.openPasteDialog
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        left: "",
                        small: "",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-clipboard-text")]
                  ),
                  _vm._v("Paste ")
                ],
                1
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "kvm-action kvm-action--green",
                  attrs: {
                    small: "",
                    tile: "",
                    outlined: "",
                    color: "primary",
                    disabled: _vm.status !== "connected",
                    "aria-label": "Send Ctrl+Alt+Del to the console"
                  },
                  on: {
                    click: _vm.sendCtrlAltDel
                  }
                },
                [_vm._v(" Ctrl+Alt+Del ")]
              )
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "520"
              },
              model: {
                value: _vm.pasteDialog,
                callback: function callback($$v) {
                  _vm.pasteDialog = $$v
                },
                expression: "pasteDialog"
              }
            },
            [
              _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-paste-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "body-1 mb-1",
                          attrs: {
                            id: "kvm-paste-title"
                          }
                        },
                        [_vm._v("Paste to console")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "kvm-caption text-caption mb-3"
                        },
                        [
                          _vm._v(
                            " Review or edit the text, then send it — it is typed into the console as keystrokes. A trailing line break will submit the line. "
                          )
                        ]
                      ),
                      _c("v-textarea", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          autofocus: "",
                          rows: 6,
                          counter: _vm.maxPaste,
                          "aria-label": "Text to send to the console",
                          placeholder: "Paste (Ctrl+V) or type text here…",
                          "hide-details": "auto"
                        },
                        on: {
                          keydown: function keydown($event) {
                            $event.stopPropagation()
                          }
                        },
                        model: {
                          value: _vm.pasteText,
                          callback: function callback($$v) {
                            _vm.pasteText = $$v
                          },
                          expression: "pasteText"
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "text-right mt-3"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "kvm-action kvm-action--green mr-2",
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.pasteDialog = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "kvm-action kvm-action--fill",
                              attrs: {
                                tile: "",
                                color: "primary",
                                disabled: !_vm.pasteText
                              },
                              on: {
                                click: _vm.sendPaste
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    left: "",
                                    small: "",
                                    "aria-hidden": "true"
                                  }
                                },
                                [_vm._v("mdi-send")]
                              ),
                              _vm._v("Send to console ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: {
                    type: "error",
                    border: "left",
                    dense: ""
                  }
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm._e(),
          _vm.server.power_state && _vm.server.power_state !== "online"
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [
                  _vm._v(
                    " This server is " +
                      _vm._s(_vm.server.power_state) +
                      ". The console will connect automatically once it is powered on. "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "p",
            {
              staticClass: "kvm-caption text-caption mb-2",
              attrs: {
                id: "kvm-console-instructions"
              }
            },
            [
              _vm._v(
                " Your keyboard and mouse control this server while this page is open. Use the Paste or Ctrl+Alt+Del buttons above; to stop sending keystrokes, focus a text field or switch to another page. "
              )
            ]
          ),
          _c(
            "div",
            {
              ref: "screen",
              staticClass: "vds-console-screen",
              style: {
                height: _vm.screenHeight + "px"
              },
              attrs: {
                role: "group",
                "aria-label": "Server console (graphical display)",
                "aria-describedby": "kvm-console-instructions"
              }
            },
            [
              _vm.status !== "connected"
                ? _c(
                    "div",
                    {
                      staticClass: "vds-console-placeholder",
                      attrs: {
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _vm.status === "connecting"
                        ? _c("v-progress-circular", {
                            staticClass: "mb-2",
                            attrs: {
                              indeterminate: "",
                              color: "primary"
                            }
                          })
                        : _vm._e(),
                      _c("div", [_vm._v(_vm._s(_vm.placeholderText))])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }